import { render, staticRenderFns } from "./ContentModal.vue?vue&type=template&id=44d8f5ed&"
import script from "./ContentModal.vue?vue&type=script&lang=ts&"
export * from "./ContentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d8f5ed')) {
      api.createRecord('44d8f5ed', component.options)
    } else {
      api.reload('44d8f5ed', component.options)
    }
    module.hot.accept("./ContentModal.vue?vue&type=template&id=44d8f5ed&", function () {
      api.rerender('44d8f5ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/components/ContentModal.vue"
export default component.exports